import {AvatarFallback} from '@radix-ui/react-avatar';
import React from 'react';

import {Avatar, AvatarImage} from '@/components/ui/avatar';

interface PartnerCardProps {
    partner: any;
}

export const PartnerCard = (props: PartnerCardProps) => {
    return (
        <div
            className="group flex h-fit min-w-[180px] snap-start flex-col   md:w-[280px]   lg:min-w-[260px]     xl:min-w-[288px]">
            <div
                className="relative flex h-[280px] w-full items-center justify-center rounded-2xl bg-[#F4F4F4] bg-cover bg-center p-2"
                style={{
                    backgroundImage: `url(${props.partner?.shop_banner_url?.url})`,
                }}
            >
                <div className="flex h-fit w-full items-center justify-between gap-2 self-end rounded-lg bg-white p-2">
                    <Avatar className="border border-black-50">
                        <AvatarImage
                            className="object-cover"
                            src={props.partner?.logo_image_url?.url}
                        />
                        <AvatarFallback className="size-full bg-neutral-200"/>
                    </Avatar>
                    {/* <Image */}
                    {/*  src={props.partner?.logo_image_url?.url} */}
                    {/*  width={48} */}
                    {/*  height={48} */}
                    {/*  quality={100} */}
                    {/*  alt={props.partner.name} */}
                    {/*  className="size-10 rounded-full bg-slate-400 object-contain object-center" */}
                    {/* /> */}

                    <span className="flex w-full flex-col  truncate">
            <h1 className="text-sm md:text-base ">{props.partner.name}</h1>
            <p className="mt-0 text-xs ">
              {props.partner.categories.join(',')}
            </p>
          </span>
                </div>
            </div>
        </div>
    );
};
